import clsx from "clsx";
import React, { DetailedHTMLProps, HTMLAttributes, ReactNode } from "react";

import Back from "~/components/Icons/arrow-prev2";
import Button from "~/shared/ui/Fields/Button";
import { Title } from "~/shared/ui/Text/Title";

import s from "./ContentWrapper.module.less";

interface IContentWrapperProps extends Omit<
  DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>,
  "className"
> {
  title: string;
  controlComponent?: ReactNode;
  filterComponent?: ReactNode;
  filterControlClassName?: string;
  additionalClassName?: string;
  titleWrapperClassName?: string;
  titleSize?: "lg" | "md" | "sm" | "xl";
  titleClassName?: string;
  txtBtn?: string;
  goBackHandler?: () => void;
}

const ContentWrapper = (props: IContentWrapperProps) => {
  const {
    title,
    children,
    controlComponent,
    filterComponent,
    filterControlClassName,
    additionalClassName,
    txtBtn,
    titleWrapperClassName,
    titleSize = "lg",
    titleClassName,
    goBackHandler,
    ...defaultDivProps
  } = props;

  return (
    <div className={clsx(s.wrapper, additionalClassName)} {...defaultDivProps}>
      {txtBtn && goBackHandler && (
        <div className={s.wrapperTxtBack}>
          <Button
            txtBtn={txtBtn}
            small
            customClassName={s.textBack}
            onClick={goBackHandler}
          >
            <Back />
          </Button>
        </div>
      )}{" "}
      <div className={clsx(s.titleContainer, titleWrapperClassName)}>
        <div
          className={clsx(
            s.title,
            !goBackHandler && s.titleNoBack,
            goBackHandler && !txtBtn && s.titleWithIconBack,
          )}
        >
          {!txtBtn && goBackHandler && (
            <Button
              txtBtn={""}
              onlyIcon
              onClick={goBackHandler}
              customClassName={s.iconBack}
            >
              <Back />
            </Button>
          )}
          <Title title={title} size={titleSize} className={titleClassName} />
        </div>
        {!!controlComponent && (
          <div className={clsx({ [s.controls]: txtBtn && goBackHandler })}>
            {controlComponent}
          </div>
        )}
      </div>
      {!!filterComponent && (
        <div className={clsx(s.filterControl, filterControlClassName)}>
          {filterComponent}
        </div>
      )}
      {children}
    </div>
  );
};

export default ContentWrapper;
